<template>
    <div class="lime-body">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                        <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb breadcrumb-separator-1">
                                    <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
                                </ol>
                            </nav>
                            <div class="page-title">
                                <h3>Financial Performance</h3>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="card stat-card">
                                <div class="card-body">
                                    <h5 class="card-title">Today</h5>
                                    <!--<div v-if="performance.performanceTodayData !== ''"><h2>${{ Number(performance.performanceTodayData).toLocaleString() }}</h2></div>-->
                                    <div v-if="performance.performanceTodayData !== ''"><h2>${{ performance.performanceTodayData }}</h2></div>
                                    <div class="progress" style="height: 10px;">
                                        <div class="progress-bar bg-warning" role="progressbar" style="width: 100%" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="card stat-card">
                                <div class="card-body">
                                    <h5 class="card-title">This Week</h5>
                                    <h2>${{ performance.performanceWeekData }}</h2>
                                    <div class="progress" style="height: 10px;">
                                        <div class="progress-bar bg-info" role="progressbar" style="width: 100%" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="card stat-card">
                                <div class="card-body">
                                    <h5 class="card-title">This Month</h5>
                                    <h2>${{ performance.performanceMonthData }}</h2>
                                    <div class="progress" style="height: 10px;">
                                        <div class="progress-bar bg-success" role="progressbar" style="width: 100%" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="card stat-card">
                                <div class="card-body">
                                    <h5 class="card-title">All Time</h5>
                                    <h2>${{ performance.performanceData }}</h2>
                                    <div class="progress" style="height: 10px;">
                                        <div class="progress-bar bg-success" role="progressbar" style="width: 100%" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">User List</h5>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">User Name</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(lastUser, index, key) in lastUsers">
                                                <td v-if="lastUser.name">{{lastUser.name}}</td>
                                                    <td v-else="lastUser.firstname && lastUser.lastname">{{lastUser.firstname}} {{lastUser.lastname}}</td>
                                                    <td v-else="lastUser.firstname">{{lastUser.firstname}}</td>
                                                    
                                                    <td><span class="badge badge-success">{{lastUser.status}}</span></td>
                                                    <!-- <td><button class="badge badge-info">View Detail</button></td> -->
                                                    <td><router-link :to="{ name: 'userDetail', params: { userId: index, page: 'dashboard' }}"><button class="badge badge-info">View Details</button></router-link></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>      
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Brand List</h5>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Brand Name</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(lastBrand, index, key) in lastBrands">
                                                    <td>{{lastBrand.brand_name}}</td>
                                                    <td><span class="badge badge-success">{{lastBrand.status}}</span></td>
                                                    <!-- <td><button class="badge badge-info">View Detail</button></td> -->
                                                    <td><router-link :to="{ name: 'brandDetail', params: { brandId: index, page: 'dashboard'}}"><button class="badge badge-info">View Details</button></router-link></td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>      
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">
                                        Last Invoices
                                        <button class="btn btn-primary" id="invoiceBtn" v-on:click="adInvoice()">Create Invoice</button>
                                    </h5>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">Invoice No.</th>
                                                    <th scope="col">Brands</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(lastInvoice, index, key) in lastInvoices">
                                                    <td v-if="lastInvoice.invoice_number !== ''">{{lastInvoice.invoice_number}}</td>
                                                    <td v-if="lastInvoice.invoice_number === ''">#TEMP{{index}}</td>
                                                    <td>{{lastInvoice.brand_name}}</td>
                                                    <!-- <td><button class="badge badge-info">View Detail</button></td> -->
                                                    <td><router-link :to="{ name: 'invoiceDetail', params: { invoiceId: lastInvoice.uid, page: 'dashboard'}}"><button class="badge badge-info">View Details</button></router-link></td>
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>      
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <!-- <h5 class="card-title">Last Payment</h5> -->
                                    <div class="table-responsive">
                                        <table class="table">
                                        </table>
                                    </div>      
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
              
                </div>
            </div>
        </div>
        </div>
        
    </div>     
</template>

<script>
import axios from 'axios'
import AddInvoice from './AddInvoice'
import Invoice from './Invoice'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'AdminDashboard',
  components: { AddInvoice,Invoice,
    Loading
  },
  data () {
    return {
      isLoading: false,
      fullPage: true,
      date: '2019-10-01 00:00:00',
      lastPayments: [],
      brands: [],
      users: [],
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      BrandDatas: [],
      lastUsers: [],
      lastBrands: [],
      errors: [],
      i: 0,
      input: {
        brandid: '',
        amount: '',
        admin: '',
        descrition: '',
        adminpercent: '',
        userA: '',
        userApercent: '',
        userB: '',
        userBpercent: '',
        duedays: ''
      },
      selectedBrand: '',
      selecteduserA: '',
      selecteduserB: '',
      selectedDays: '',
      performance: ''
    }
  },
  methods: {
    adInvoice () {
      this.$modal.show(AddInvoice, { height: '100%' })
    },
    invoiceClose () {
      this.input.amount = ''
      this.input.description = ''
      this.input.adminpercent = ''
      this.input.userApercent = ''
      this.input.userBpercent = ''
      this.input.brandid = ''
      this.input.admin = ''
      this.input.userA = ''
      this.input.userB = ''
      this.input.duedays = ''
      document.getElementById('brand-logo').style.display = 'none'
      document.getElementById('brandDetail').style.display = 'none'
    },
    method1 () {
      document.body.addEventListener('click', function () {
        var body2 = document.body
        body2.classList.remove('background--blur')
        body2.classList.remove('sidebar-show')
        window.onload = function () {
          document.getElementById('navigation-toggle1').style.display = 'block'
          document.getElementById('navigation-toggle2').style.display = 'none'
        }
      }, true)
    },
    changeDays (event) {
      this.selectedDays = event.target.options[event.target.options.selectedIndex].value
      document.getElementById('draft').style.display = 'none'
      document.getElementById('adddatepick_hide').style.display = 'none'
    },
    click () {
      document.body.addEventListener('click', function () {
        var modal = document.getElementById('createInvoice')
        var span = document.getElementById('close1')
        span.onclick = function () {
          modal.style.display = 'none'
        }
        window.onclick = function (event) {
          if (event.target === modal) {
            modal.style.display = 'none'
          }
        }
      }, true)
    },
    // deleteInvoice (uid) {
    //   var jwttoken = localStorage.getItem('jwt')
    //   if (confirm('Do you really want to delete?')) {
    //     this.isLoading = true
    //     axios.delete('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/deleteInvoice' + '?' + 'uid' + '=' + uid, {
    //       headers: {
    //         'x-access-token': jwttoken
    //       }})
    //       .then(response => {
    //         this.isLoading = false
    //         console.log(response)
    //         axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllInvoices', {
    //           headers: {
    //             'x-access-token': jwttoken
    //           }})
    //           .then(response => {
    //             this.invoiceDatas = response.data.results.InvoiceData
    //             this.invoicePartiesPercentageDatas = response.data.results.invoicePartiesPercentageData
    //           })
    //           .catch((error) => {
    //             console.log(error)
    //             this.isLoading = false
    //           })
    //       })
    //   }
    // },
    changeBrand (event) {
      this.selectedBrand = event.target.options[event.target.options.selectedIndex].value
      console.log(this.selectedBrand)
    },
    changeUserFirst () {
      this.selecteduserA = event.target.options[event.target.options.selectedIndex].value
      console.log(this.selecteduserA)
    },
    changeUserSecond () {
      this.selecteduserB = event.target.options[event.target.options.selectedIndex].value
      console.log(this.selecteduserB)
    },
    getBrands () {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.brands = response.data.results[0]
          console.log(this.brands)
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    },
    getUsers () {
      this.isLoading = true
      var jwttoken = localStorage.getItem('jwt')
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllUsers', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.users = response.data.results[0]
          console.log(this.users)
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    },
    getInvoice () {
      this.isLoading = true
      var jwttoken = localStorage.getItem('jwt')
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllInvoices', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.BrandDatas = response.data.results.BrandData
          this.invoiceDatas = response.data.results.InvoiceData
          this.invoicePartiesPercentageDatas = response.data.results.invoicePartiesPercentageData
          console.log(this.results)
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    },
    showInvoice (invoiceId) {
      var jwttoken = localStorage.getItem('jwt')
      console.log(invoiceId)
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getInvoiceById' + '?' + 'invoice_id' + '=' + invoiceId, {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    },
    getLastPayment () {
      this.isLoading = true
      var jwttoken = localStorage.getItem('jwt')
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getLatestPayments', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.lastPayments = response.data.results
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    },
    getLastInvoices () {
      this.lastInvoices = []
      this.isLoading = true
      var jwttoken = localStorage.getItem('jwt')
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getLatestInvoices', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.lastInvoices = response.data.results.InvoiceData
          console.log(response)
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    },
    getLastUsers () {
      this.isLoading = true
      var jwttoken = localStorage.getItem('jwt')
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getLatestUsers', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.lastUsers = response.data.results[0]
          console.log(this.lastUsers)
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    },
    getLastbrands () {
      this.isLoading = true
      var jwttoken = localStorage.getItem('jwt')
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getLatestBrands', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.lastBrands = response.data.results[0]
          console.log(this.lastBrands)
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    },
    getPerformance () {
      this.isLoading = true
      var jwttoken = localStorage.getItem('jwt')
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getPerformance', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.performance = response.data.results
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    }
  },
  created () {
    this.getBrands()
    this.getUsers()
    this.getInvoice()
    this.getLastInvoices() ;
  },
  mounted () {
    this.$eventBus.$on('latestDashbordList', () => { 
    // alert('helo')
    this.getLastInvoices() ;
    this.getLastUsers();
    this.getLastbrands()
    this.getLastPayment()
    this.$forceUpdate();

    })
    this.method1()
    this.click()
    this.getLastPayment()
    this.getLastInvoices()
    this.getLastUsers()
    this.getLastbrands()
    this.getPerformance()  
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminDashboard.vue